<template>
    <article class="f fh fa-c fj-sb pr sp-s">
        <i v-if="entity.icon" :class="entity.icon" class="sm-r-m"></i>
        <div class="f fv fg o-ol">
            <span v-if="entity.eyebrow" class="te-note">{{ entity.eyebrow | athT }}</span>
            <h6 class="fg o-ol te-title-entity">
                {{ entity.title | athT }}
            </h6>
            <span v-if="entity.subtitle" class="te-note">{{ entity.subtitle | athT }}</span>
        </div>
        <Badge v-if="entity.badgeText" :lbl="entity.badgeText" :cname="entity.badgeStyle" />
    </article>
</template>

<script>
import Badge from '../atoms/visuals/Badge.vue';
export default {
    name: 'mead-entity',
    components: {
        Badge,
    },
    props: {
        /**
         * The entity data to display, with optional icon, eyebrow text, title,
         * subtitle, and badge (badgeText/badgeStyle) fields.
         */
        entity: {type: Object, required: true},
    },
};
</script>

<style lang="scss" scoped>
@use '../../../sass/variables' as *;
i {
    font-size: $fs-giga;
}
</style>
